module.exports = __webpack_public_path__ + "static/img/news_gzh_02_zh.dc50fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news_gzh_02_zh.png
// module id = T+XF
// module chunks = 34